<template>
  <div>
    <el-dialog
      top="20vh"
      width="400px"
      center
      :title="`${operableVerificationCodeObj.bankName} 验证码信息`"
      :visible="operableVerificationCodeObj.visible"
      @close="HandleCancel()"
    >
      <div v-loading="operableVerificationCodeLoading">
        <div v-if="!rowObj.smsConstant">暂无资料</div>
        <div v-else>
          <div
            class="sms cursorPointer"
            @click="
              CopyTextToClipboard(
                rowObj.smsConstant ? rowObj.smsConstant : '',
                '复制成功'
              )
            "
          >
            {{ rowObj.smsConstant ? rowObj.smsConstant : "" }}
            <i class="el-icon-document-copy" />
          </div>
          <br />
          <div>
            <span
              class="cursorPointer"
              style="
                width: 100%;
                text-align: center;
                font-weight: 500;
                font-size: 14px;
              "
              @click="CopyTextToClipboard(rowObj.verifyCode)"
            >
              验证码：{{ rowObj.verifyCode ? rowObj.verifyCode : "" }}
              <i class="el-icon-document-copy" />
            </span>
          </div>
          <br />
          <div>
            获取时间：{{ rowObj.receiveTime ? rowObj.receiveTime : "" }}
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-row>
          <div style="float: right">
            <el-button
              icon="el-icon-refresh-left"
              type="success"
              size="small"
              @click="getBankAccountVerificationCode()"
            >
              刷新
            </el-button>
            <el-button type="primary" size="small" @click="HandleCancel()">
              确定
            </el-button>
          </div>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { getBankAccountVerificationCode } from "@/api/bank";

export default {
  mixins: [mainCommon],
  props: ["operableVerificationCodeObj"],
  data() {
    return {
      operableVerificationCodeLoading: false, // 验证码弹窗 loading
      rowObj: {},
    };
  },
  watch: {
    operableVerificationCodeObj(row) {
      if (row.visible) {
        this.getBankAccountVerificationCode();
      }
    },
  },
  methods: {
    getBankAccountVerificationCode() {
      this.operableVerificationCodeLoading = true;
      getBankAccountVerificationCode(this.operableVerificationCodeObj.id)
        .then((res) => {
          setTimeout(() => {
            this.rowObj = {
              id: this.operableVerificationCodeObj.id,
              bankName: this.operableVerificationCodeObj.bankName,
              smsConstant: res.data ? res.data.smsConstant : "",
              verifyCode: res.data ? res.data.verifyCode : "",
              receiveTime: res.data ? res.data.receiveTime : "",
            };
          }, 200);
        })
        .finally(() => {
          this.operableVerificationCodeLoading = false;
        });
    },
    HandleCancel() {
      this.$emit("update:operable-verification-code-obj", {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/OperableVerificationCode.vue